import React, { useContext } from 'react';
import { RTLContext } from '../../App';

const AppFooter = (props) => {

    const isRTL = useContext(RTLContext);

    return <div className="layout-footer flex align-items-center px-4 py-2 shadow-2">
        <p className={!isRTL ? 'mr-auto' : 'ml-auto' }>Powered by Nextqore ©2022-2023.</p>
    </div>

}

export default AppFooter;
